import styled from 'styled-components';
import { AppBaseSelect } from 'components/atoms';

export const StyledSelect = styled(AppBaseSelect)`
    .ant-select-selector .ant-select-selection-item {
        padding-inline-end: 30px;
    }
`;
